<template>
    <UnauthCOmp></UnauthCOmp>
  </template>
  <script>
  import UnauthCOmp from "../../components/Error/UnAuthorized.vue";
  
  export default {
    name: "UnauthCOmp",
    components: { UnauthCOmp },
    computed: {},
    mounted() {},
  };
  </script>
  